import { createContext } from 'react';

const nivel3Context = createContext();

export default nivel3Context;
